import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CiacService } from 'src/app/services/http/ciac.service';

@Component({
  selector: 'app-historico-dce',
  templateUrl: './historico-dce.component.html',
  styleUrls: ['./historico-dce.component.scss']
})
export class HistoricoDceComponent implements OnInit {

  @Input() id;

  sorting: { 
    id: "asc",
  }

  filter = {
    sorting: { 
      id: "asc",
    },
    filter: {
      nome: "",
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };

  total:number = 1;
  listaDadosEntrada = [];
  tableLoading = false;

  constructor(private router: Router, private modalService: NgbModal, private modalMsgService: ModalMsgService, private ciacService: CiacService) { }

  ngOnInit() {
    this.getListaDadosEntrada();
  }

  getListaDadosEntrada() {
    this.filter.sorting = this.removeEmpty({ ...this.sorting });
    let filtro = {
      ...this.filter,
      idConsultaFornecedor: parseInt(this.id)
    }
    let dataUpdate = filtro.data;
    this.ciacService.getDadosEntrada(filtro).then(c => {
      if(dataUpdate == filtro.data) {
        this.tableLoading = false;
        this.total = c.total || 0;
        this.listaDadosEntrada = c.lista || [];
      }
    });
    if(this.listaDadosEntrada.length == 0) {
      this.tableLoading = false;
    }
  }

  removeEmpty(obj) {
    this.listaDadosEntrada = [];
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  setPageSize(pageSize) {
    this.filter.page = 1;
    this.filter.per_page = pageSize;
    this.getListaDadosEntrada();
  }

  nextPage() {
    this.getListaDadosEntrada();
  }

  editDadoEntrada(id) {
    this.ciacService.getDadosConsultaEntrada(id);
  }

  delDadoEntrada(id) {
    let params = {
      id: parseInt(id)
    }
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Remover dado entrada';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.ciacService.delDadosEntrada(justificativa, params)
          .then(r => this.getListaDadosEntrada())
          .catch(e => this.modalMsgService.openDialog('Erro ao remover dado entrada', '', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao remover dado entrada',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao remover dado entrada',
      'Informe uma Justificativa para concluir a operação', 'danger'));
  }

}
